module.exports = __webpack_public_path__ + "img/video1.8bc258c8.jpg";